import { Combobox as ComboboxPrimitive } from '@base-ui/react/combobox';
import { Search } from 'lucide-react';

const SEARCH_FIELD_CLASS = [
  'mb-1.5 flex h-9 shrink-0 items-center gap-2 rounded-xl bg-primary/5 px-3 ring-1 ring-primary/12',
  'transition-[background-color,box-shadow] duration-200 motion-reduce:transition-none',
  'focus-within:bg-card focus-within:ring-2 focus-within:ring-primary/35',
].join(' ');
const SEARCH_INPUT_CLASS =
  'h-full w-full min-w-0 bg-transparent text-sm outline-none placeholder:text-placeholder';

type ComboboxSearchFieldProps = Omit<ComboboxPrimitive.Input.Props, 'className'>;

export function ComboboxSearchField(props: ComboboxSearchFieldProps) {
  return (
    <div className={SEARCH_FIELD_CLASS}>
      <Search className="size-4 shrink-0 text-primary/60" aria-hidden />
      <ComboboxPrimitive.Input {...props} className={SEARCH_INPUT_CLASS} />
    </div>
  );
}
